import React from 'react';

/** Customer-visible catalog reference for search, cart, and WhatsApp inquiries. */
export default function ProductRefId({ id, className = 'product-id', as: Tag = 'div' }) {
  const ref = String(id ?? '').trim();
  if (!ref) return null;
  return (
    <Tag className={className}>
      Product ID: <span className="product-id__value">{ref}</span>
    </Tag>
  );
}
